//@ts-ignore
import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers';
import { CustomEmoji } from 'app/scripts/models/CustomEmoji';

class CustomEmojiList extends CollectionWithHelpers {
  static initClass() {
    // @ts-ignore
    this.prototype.model = CustomEmoji;
  }
  url() {
    // @ts-ignore
    return `/1/member/${this.member.id}/customEmoji`;
  }

  // @ts-ignore
  initialize(list, { member }) {
    // @ts-ignore
    this.member = member;
  }
}
CustomEmojiList.initClass();

export { CustomEmojiList };
